import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export function getUserCount(
    userRole: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<number>> {
    return client.get<number>(`/user_count/${userRole}`, customConfig);
}
